/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Update_DetailInputs */

const en_update_detail = /** @type {(inputs: Update_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reload to use it.`)
};

const de_update_detail = /** @type {(inputs: Update_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neu laden, um es zu übernehmen.`)
};

/**
* | output |
* | --- |
* | "Reload to use it." |
*
* @param {Update_DetailInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const update_detail = /** @type {((inputs?: Update_DetailInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Update_DetailInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_update_detail(inputs)
	return en_update_detail(inputs)
});